import { Draggable } from "@hello-pangea/dnd";
import "./Field.scss";
import { useState, useEffect } from "react";
import FieldDialog from "../../Dialogs/FieldDialog";
import Button from "../../../../buttons/Button";
import { buildUrl } from "../../../../utils/helper";

export default function Field({
  deleteField,
  setIsOpenedFieldDialog,
  setIsOpenedDialog,
  buildArea,
  setBuildArea,
  rowIndex,
  columnIndex,
  fieldIndex,
  field,
}) {
  const [isOpen, setIsOpen] = useState(false);

  // notify parent dialogs about open state
  useEffect(() => {
    setIsOpenedFieldDialog(isOpen);
    setIsOpenedDialog(isOpen);
  }, [isOpen, setIsOpenedFieldDialog, setIsOpenedDialog]);

  const handleDelete = () => {
    deleteField(rowIndex, columnIndex, fieldIndex);
  };

  return (
    <>
      {isOpen && (
        <FieldDialog
          setOpen={setIsOpen}
          isOpen={isOpen}
          buildArea={buildArea}
          setBuildArea={setBuildArea}
          rowI={rowIndex}
          colI={columnIndex}
          fieldI={fieldIndex}
          field={field}
        />
      )}

      <Draggable
        key={field.field}
        draggableId={field.field}
        index={fieldIndex}
        type="field"
      >
        {(provided) => (
          <div
            className="field"
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            style={provided.draggableProps.style}
          >
            <div>
              {console.log(field)}
              {field.ui_type === 'title' && `Nadpis: ${field.title}` }
              {field.ui_type === 'customComponent' && `Vlastný komponent: ${field.customComponent}`}
              {field.ui_type === 'db_field' && field.title}
            </div>
            <div className="edit-buttons">
              <span>
                {field.customWidth === 'detail-large' && '70%'}
                {field.customWidth === 'detail-small' && '30%'}
              </span>
              <Button
                onClick={() => setIsOpen(true)}
                imageUrl={buildUrl('assets/icons/toolbar/edit.svg')}
                title="Nastavenie komponentu"
                className="edit-icon"
              />
              <Button
                onClick={handleDelete}
                imageUrl={buildUrl('assets/icons/close.svg')}
                title="Vymazať komponent"
                className="delete-icon"
              />
            </div>
          </div>
        )}
      </Draggable>
    </>
  );
}
